import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ROLES } from '@/helpers/constants';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { createWithdrawRequest, getWithdrawInfo } from '@/store/actions/paymentActions';
import { useUserStore } from '@/store/userStore';
import Preloader from '@/components/UI/Preloader';
import WithdrawForm from '@/components/Forms/WithdrawForm';
import { AccountTypeTabs } from '@/components/AccountTypeTabs';
import WithdrawHistory from './history';
import s from './index.module.scss';

export const WithdrawModule = () => {
  const { user } = useGetMe();
  const dispatch = useDispatch();
  const { accountType } = useUserStore();
  const [tab, setTab] = useState(accountType);
  const { t } = useTranslation('withdraw');
  const [historyUpdater, setHistoryUpdater] = useState(new Date().toISOString()); // Used to force update Withdrawals history
  const { data, loading } = useSelector(state => state.paymentStore.withdrawInfo);
  const hasExternalAcc = !!data?.external_accounts?.length;

  useEffect(() => {
    dispatch(getWithdrawInfo({ main_account_type: tab }));
  }, [tab]);

  const onSubmit = async (values, formikBag) => {
    const payload = {
      account: values.account.id,
      amount: values.amount,
      account_type: tab,
    };

    const res = await dispatch(createWithdrawRequest(payload));
    if (res && res.success) {
      setHistoryUpdater(new Date().toISOString()); // Force update Withdrawals History
      formikBag.resetForm();
      formikBag.setValues({ account: values.account, amount: '' });
    }
  };

  if (!user) return null;

  return (
    <div className={s.wrapper}>
      <AccountTypeTabs selected={tab} className="withdraw-form__tabs" onChange={setTab} />
      {loading ? (
        <Preloader className={s.preloader} />
      ) : hasExternalAcc ? (
        <WithdrawForm
          accountType={tab}
          balance={data && data.cash}
          accounts={data && data.external_accounts}
          onSubmit={onSubmit}
        >
          {user.role === ROLES.founder && (
            <WithdrawHistory accountType={tab} resetTime={historyUpdater} className={s.history} />
          )}
        </WithdrawForm>
      ) : (
        <div>
          <h1 className={classnames('f-26 f-500')}>{t('withdraw_page.bank_account_info')}</h1>
          <p className={classnames(s.description, 'f-20 f-500')}>
            {t('withdraw_page.withdrawals_availability')}
          </p>
        </div>
      )}
    </div>
  );
};
